export default function Node_Readline() {
  return <div>Node_Readline Component</div>;
}
